'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boolean = function boolean() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var props = _ref.props;

  var Boolean = function Boolean(_ref2) {
    var value = _ref2.value;
    var onValue = _ref2.onValue;
    return _react2.default.createElement(
      'div',
      props,
      _react2.default.createElement(
        'button',
        {
          disabled: value,
          onClick: function onClick() {
            return onValue(true);
          }
        },
        '✓'
      ),
      _react2.default.createElement(
        'button',
        {
          disabled: !value,
          onClick: function onClick() {
            return onValue(false);
          }
        },
        '✗'
      )
    );
  };
  process.env.NODE_ENV !== "production" ? Boolean.propTypes = {
    value: _react2.default.PropTypes.any,
    onValue: _react2.default.PropTypes.func
  } : void 0;

  return Boolean;
};

exports.default = boolean;


//////////////////
// WEBPACK FOOTER
// ./~/react-edit/dist/boolean.js
// module id = 1265
// module chunks = 0